module.exports = __webpack_public_path__ + "img/ji8.7b89ed13.png";